module.exports = __webpack_public_path__ + "img/img2.d1a6f399.jpg";